import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface AccountsReceivablePaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const AccountsReceivablePaymentSection: React.FC<AccountsReceivablePaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Referencia de Cuentas por Pagar"
        name="accountsReceivableVoucher"
        iconKey="payment" // 👈 puedes reemplazarlo por un ícono específico si lo tienes
        type="text"
        placeholder="Ingrese la referencia o número de cuenta"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default AccountsReceivablePaymentSection;
